import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Sublinks from "../components/sublinks"
import Infolinia from "../components/infolinia"
import NewsItem from "../components/News/newsitem"

import '../sass/main.scss'

const query = graphql`
  {
    fotka: file(relativePath: { eq: "sub-visual-news.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1920) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    newsCollection: allStrapiNewsPosts(sort: { order: DESC, fields: date }) {
      nodes {
        title
        thumb {
          childImageSharp {
            fluid(quality: 90) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        date(formatString: "YYYY MM DD")
        excerpt
        slug
        id
      }
    }
  }
`

const ListaAktualnosci = () => {
    const data = useStaticQuery(query)

  return (
    <Layout>
      <SEO title="ORLEN | News" />
      <Sublinks />

      <BackgroundImage
        Tag="section"
        className={`sub-visual sub-visual-news`}
        fluid={data.fotka.childImageSharp.fluid}
        backgroundColor={`#000`}
      >
        <div className="bg-overlay"></div>
        <div className="visual-content col-md-8">
          <div className="title text-center">NEWS</div>
        </div>
        <Infolinia customStyle="d-none d-md-flex js-infolinia" />
      </BackgroundImage>

      <div className="news-holder container">
        <div className="row mb-xl-5">
          {data.newsCollection.nodes.map((news, i) => (
            <NewsItem key={news.id} {...news} />
          ))}
        </div>
      </div>
    </Layout>
  )
}
export default ListaAktualnosci



